var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub_title_container",class:_vm.size},[_c('div',{staticClass:"sub_title_text"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"sub_title_btns"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }